var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_176_30202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6443 7.76409C16.6443 7.64623 16.5478 7.54981 16.43 7.54981L14.6621 7.55784L11.9996 10.7319L9.3398 7.56052L7.56927 7.55248C7.45141 7.55248 7.35498 7.64623 7.35498 7.76677C7.35498 7.81766 7.37373 7.86588 7.40587 7.90606L10.8907 12.0578L7.40587 16.2069C7.37351 16.2462 7.35555 16.2954 7.35498 16.3462C7.35498 16.4641 7.45141 16.5605 7.56927 16.5605L9.3398 16.5525L11.9996 13.3784L14.6594 16.5498L16.4273 16.5578C16.5452 16.5578 16.6416 16.4641 16.6416 16.3436C16.6416 16.2927 16.6228 16.2444 16.5907 16.2043L13.1112 12.0552L16.5961 7.90338C16.6282 7.86588 16.6443 7.81498 16.6443 7.76409Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37321 0 0 5.37321 0 12C0 18.6268 5.37321 24 12 24C18.6268 24 24 18.6268 24 12C24 5.37321 18.6268 0 12 0ZM12 21.9643C6.49821 21.9643 2.03571 17.5018 2.03571 12C2.03571 6.49821 6.49821 2.03571 12 2.03571C17.5018 2.03571 21.9643 6.49821 21.9643 12C21.9643 17.5018 17.5018 21.9643 12 21.9643Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_30202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.32611bc74bcad8e6bcc33ccb57ab67c2.svg";
export { ForwardRef as ReactComponent };